import { roomHarvestFreshness } from "@shared/room-harvest-freshness";
type HarvestRoom = {
  id: number; padsplitRoomId: string | null; lastHarvested: Date | string | null;
  currentPrice: string | null; recommendedPrice: string | null;
  harvestRefresh?: { state: string; observation: string | null } | null;
};
const labels: Record<string, string> = {
  pending: "Awaiting daily request", requested: "Request outcome pending",
  accepted: "Request accepted", already_queued: "Already queued",
  failed: "Request failed", skipped: "Refresh skipped", unavailable: "Refresh evidence unavailable",
};
export function RoomHarvestFreshness({ room }: { room: HarvestRoom }) {
  if (!room.padsplitRoomId) return null;
  const age = roomHarvestFreshness(room.lastHarvested);
  const refresh = room.harvestRefresh;
  return (
    <div className="mt-1 text-xs font-normal text-muted-foreground whitespace-nowrap"
      data-testid={`room-harvest-freshness-${room.id}`}
      title="Harvest freshness only. This timestamp does not verify pricing extraction or that prices match PadSplit. Daily requests begin at 09:25 UTC. Harvest age is stale after 48 hours.">
      <div className={age.state === "recent" ? "" : "text-amber-700 dark:text-amber-400"}>
        {age.label}{age.state === "stale" ? " · Stale harvest" : ""}
      </div>
      {(room.currentPrice == null || room.recommendedPrice == null) && <div>Pricing data missing</div>}
      {refresh && <div>{labels[refresh.state] ?? refresh.state}{
        refresh.observation === "overdue" ? " · Observation overdue" :
        refresh.observation === "harvest_observed" ? " · Harvest observed" :
        refresh.observation === "pending" ? " · Awaiting harvest observation" : ""}</div>}
      <div>Harvest freshness, not verified price freshness</div>
    </div>
  );
}
